import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EApiType } from 'common/enums/api-type.enum';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  burnEmissionService,
  issueEmissionService,
  setAdminEmissionCancelService,
  setAdminEmissionConfirmService,
} from '../services/emission.service';
import {
  TEmissionHistoryReqParams,
  TEmissionHistoryResData,
  TIssueBurnEmissionReqParams,
} from '../types/emission.types';

export const useGetEmissionHistoryMultiRoleQuery = (
  type: EApiType,
  counterpartyGUID: string,
  params?: TEmissionHistoryReqParams,
  options?: any,
): UseQueryResult<TEmissionHistoryResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.EmissionQueryKeys].getEmissionHistory_MultiRole(type, counterpartyGUID, params),
    ...options,
  });

export const useIssueEmissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; params: TIssueBurnEmissionReqParams }) =>
      issueEmissionService(data.counterpartyGUID, data.params),
  });

export const useBurnEmissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; params: TIssueBurnEmissionReqParams }) =>
      burnEmissionService(data.counterpartyGUID, data.params),
  });

export const useConfirmEmissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { assetHistoryRecordGUID: string }) =>
      setAdminEmissionConfirmService(data.assetHistoryRecordGUID),
  });

export const useCancelEmissionMutation = (): any =>
  useMutation({
    mutationFn: (data: { assetHistoryRecordGUID: string }) =>
      setAdminEmissionCancelService(data.assetHistoryRecordGUID),
  });
